import { Route } from "@angular/router";
import { AuthGuard, LoginGuard, LoginMatchGuard } from "core";
import { BaseLayoutComponent } from "../components/base-layout/base-layout";

export const baseRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    {
        path: 'login',
        canActivate: [LoginGuard],
        canMatch: [LoginMatchGuard],
        loadComponent: () => import('../pages/login/login').then(m => m.Login)
    },
    { path: 'auth/callback', loadComponent: () => import('../pages/auth-callback/auth-callback').then(m => m.AuthCallback) },
	// { path: 'recover-password', loadComponent: () => import('../pages/recover-password/recover-password').then(m => m.RecoverPassword) }
];

export const baseAuthenticatedRoute: Route = {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: BaseLayoutComponent,
    children: [
        { path: 'dashboard', loadComponent: () => import('../pages/dashboard/dashboard').then(m => m.Dashboard) },
        { path: 'profile', loadComponent: () => import('../pages/profile/profile').then(m => m.Profile) },
        { path: 'test', loadComponent: () => import('test').then(m => m.AccessibilityTestpage) },
        { path: 'test-transloco', loadComponent: () => import('test').then(m => m.TestPage) },
    ]
};

// Ultima nella lista di route (wildcard)
export const defaultRoute: Route = {
    path: '**', pathMatch: 'full', redirectTo: 'dashboard'
};
